import { useTranslation } from 'react-i18next'

import { ApiError } from '@/api/client'

/**
 * Μεταφράζει σφάλμα API σε μήνυμα i18n.
 *
 * Το backend επιστρέφει σταθερό κωδικό, όχι έτοιμο κείμενο, ώστε η γλώσσα της
 * διεπαφής να καθορίζεται αποκλειστικά από το frontend (§13).
 */
export function useApiError() {
  const { t } = useTranslation()

  return (error: unknown): string => {
    if (error instanceof ApiError) {
      const key = `errors.${error.code}`
      const translated = t(key)
      return translated === key ? t('errors.internal_error') : translated
    }
    return t('errors.network')
  }
}
